import React from "react";
import Alert from "../UI/Alerts/Alert";
import styled from "styled-components";
import Anchor from "../../../components/Router/Anchor";
import getInternetExplorerVersion from "../../../lib/browser/getInternetExplorerVersion";

const BrowserSupportAlert = styled(Alert)`
    & {
        margin: 20px;
    }
`;

const BrowserSupport: React.FC = (props) =>
{
    if (getInternetExplorerVersion() > -1)
    {
        return (
            <BrowserSupportAlert>
                <strong>Undskyld, vi supporterer ikke længere Internet Explorer</strong>
                <p>Som browser lever Explorer desværre ikke op til vores sikkerhedskrav på
                    <Anchor to={"https://www.aarhusteater.dk/"}> aarhusteater.dk</Anchor><br />
                    Venligst opdater til&nbsp;
                    <Anchor to={"https://www.google.com/chrome/"}>Google Chrome</Anchor>,&nbsp;
                    <Anchor to={"https://getfirefox.com/"}>Firefox</Anchor>,
                    eller <Anchor to={"https://www.microsoft.com/edge/"}>Microsoft Edge</Anchor>.
                    <br /><br />
                    Aarhus Teater<br />
                    <Anchor to={"mailto:info@aarhusteater.dk"}>info@aarhusteater.dk</Anchor>
                </p>
            </BrowserSupportAlert>
        );
    }
    else return (
        <>
            {props.children}
        </>
    );
};

export default BrowserSupport;